<template>
  <a-modal
    :title="$t('快捷登录')"
    class="login-alert"
    :maskClosable="false"
    :visible="visible || isLogin"
    :width="350"
    :confirm-loading="confirmLoading"
    :footer="null"
    @cancel="onCancel"
  >
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" :tab="$t('微信登录')">
        <wxlogin
          :appid="wxConfig.appid"
          :scope="wxConfig.scope"
          :redirect_uri="wxConfig.redirect_uri"
          :state="wxConfig.state"
          :self_redirect="'false'"
          :href="wxloginCss"
        ></wxlogin>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('账户登录')" force-render>
        <a-form
          :form="form"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 18 }"
          @submit="handleSubmit"
          layout="inline"
        >
          <a-form-item :wrapperCol="{  offse: 1 }">
            <a-input
              v-decorator="['username', { rules: [{ required: true, message: $t('请输入账号') }] }]"
              :placeholder="$t('请输入账号')"
              style="width: 240px;margin-left: 30px;"
            >
              <a-icon slot="addonBefore" type="user" />
            </a-input>
          </a-form-item>
          <a-form-item :wrapperCol="{ offse: 1 }">
            <a-input
              type="password"
              v-decorator="['password', { rules: [{ required: true, message: $t('请输入密码') }] }]"
              :placeholder="$t('请输入密码')"
              style="width: 240px;margin-left: 30px;"
            >
              <a-icon slot="addonBefore" type="lock" />
            </a-input>
          </a-form-item>
          <a-form-item style="width:98%">
            <a-button style="margin-left:40px" type="primary" html-type="submit" block>
              {{ $t('登录') }}
            </a-button>
          </a-form-item>
          <a-form-item :wrapperCol="{ span: 24 }">
            <div style="text-align: center;width: 100%;">
              <a-button type="link" @click="$refs.registByMail.show()">{{ $t('账号注册') }}</a-button>
              <a-button type="link" @click="$refs.resetPassword.showModal()">{{ $t('忘记密码') }}？</a-button>
            </div>
            <!-- <span
              style="cursor: pointer;display:block;width:100%;margin-left:45px;"
              @click="$refs.resetPassword.showModal()"
              >忘记密码？</span
            > -->
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
    <ResetPassword ref="resetPassword" />
    <RegistByMail ref="registByMail"/>
  </a-modal>
</template>

<script>
import store from '@/store'
import appConfig from '../config/appConfig'
import ResetPassword from './modal/ResetPassword'
import RegistByMail from './modal/RegistByMail'
import wxlogin from 'vue-wxlogin'
import { createNamespacedHelpers, mapState } from 'vuex'
const { mapActions } = createNamespacedHelpers('user')
export default {
  name: 'Home',
  components: {
    wxlogin,
    ResetPassword,
    RegistByMail
  },
  created() {},
  destroyed() {},
  mounted() {},
  data() {
    return {
      visible: false, // 登录弹窗
      confirmLoading: false, // 登录弹窗loading，
      form: this.$form.createForm(this, { name: 'coordinated' }),
      username: '',
      password: '',
      wxloginCss: 'https://static.daoba.com/wx.css', // 微信登录样式，需要可以在浏览器上访问得到的路径
      wxConfig: {
        appid: appConfig.wechatAppId,
        scope: 'snsapi_login',
        redirect_uri:
          appConfig.loginCallback +
          encodeURIComponent(window.location.host + window.location.pathname + window.location.search),
        state: 'open_platform',
      },
    }
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      token: (state) => state.user.accessToken,
    }),
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    show() {
      store.commit('user/USER_CHANGE_LOGIN_URL', this.$route.fullPath)
      // 打开登录弹窗
      this.visible = true
    },
    callback(key) {
      // 选项卡切换
      console.log(key)
    },
    onCancel() {
      // 选项卡切换
      this.visible = false
      if (!this.token) {
        const fromPath = localStorage.getItem('fromPath')
        window.location.href = fromPath
      }
      store.commit('user/USER_CHANGE_IS_LOGIN', false)
    },
    handleSubmit(e) {
      // 账号密码登录按钮
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values['grant_type'] = 'password'
          values['client_secret'] = '123456'
          values['client_id'] = 'app'
          const { Login } = this
          Login(values)
            .then((res) => this.loginSuccess(res, values))
            .catch((err) => this.requestFailed(err))
            .finally(() => {})
        }
      })
    },
    loginSuccess(res, values) {
      // 如果登录成功
      if (res.status === 0) {
        this.onCancel()
        this.$api.user.userInfo({}).then((info) => {
          if (info.status === 0) {
            store.commit('user/USER_CHANGE_USER_INFO', info.data)
            this.$notification['success']({
              message: '登录成功',
              description: '',
              duration: 4,
            })
            window.location.href = store.getters['user/loginUrl']
          }
        })
      }
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: err,
        duration: 4,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .ant-row,
.ant-form-item {
  // width: 300px;
  margin: 10px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  // padding: 0 30px;
  margin-bottom: 30px;
}
.login-out {
  cursor: pointer;
  &:hover {
    color: #a80000;
  }
}
.login-alert {
  background-color: #d60701;
}
.iframe-warp {
  width: 0;
  height: 0;
  display: none;
}
.login-warp {
  position: absolute;
  top: -318px;
  right: 20px;

  height: 30px;
}
.user-img {
  width: 36px;
  border-radius: 50%;
}
.login-btn {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  color: #a80000;
  background: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  outline: none;
  &:hover {
    background: #ffd5d5;
  }
}
.ercode {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 150px;
}
.text-center {
  text-align: center;
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/Login.vue